export const setShow = 'CODECASTS_LOADER/setShow'



// WEBPACK FOOTER //
// ./src/plugins/loader/vuex/mutations-type.js